/**
 * @generated SignedSource<<1b4c206501db2ca5a68f4a6129d1a729>>
 * @relayHash d6d2c3d7f03461063a5fa739fc90f661
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 36d7971b58c17507520135674b8261ab5cbe636d62b35c3d988449c193468c4c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraSoftwareTimelineAppQuery } from './JiraSoftwareTimelineAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraSoftwareTimelineAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "36d7971b58c17507520135674b8261ab5cbe636d62b35c3d988449c193468c4c",
    "metadata": {},
    "name": "JiraSoftwareTimelineAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
